/*
 * Hamilton Sinkler Custom Wishlist Core
 * Description: Creates the shared window.HSWishlist namespace, module registry, and event helpers.
 * Dependencies: window.CustomEvent
 * Public Methods: define, get, emit, on, ready
 * Private Methods: freezeDetail
 * Version: 1.0.0
 */
(function (window, document) {
  'use strict';

  var namespace = window.HSWishlist || {};
  var modules = namespace.modules || {};

  function freezeDetail(detail) {
    if (!detail || typeof detail !== 'object') return detail;
    return Object.freeze(Object.assign({}, detail));
  }

  /** Registers a public module under window.HSWishlist.modules. */
  namespace.define = function define(name, module) {
    if (!name || modules[name]) return modules[name];
    modules[name] = Object.freeze(module);
    return modules[name];
  };

  /** Returns a registered wishlist module by name. */
  namespace.get = function get(name) {
    return modules[name];
  };

  /** Dispatches a wishlist CustomEvent from document. */
  namespace.emit = function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: freezeDetail(detail) }));
  };

  /** Subscribes to a wishlist CustomEvent and returns an unsubscribe function. */
  namespace.on = function on(name, handler) {
    document.addEventListener(name, handler);
    return function unsubscribe() { document.removeEventListener(name, handler); };
  };

  /** Runs a callback when the DOM is safe to query. */
  namespace.ready = function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  namespace.modules = modules;
  namespace.version = '1.0.0';
  window.HSWishlist = namespace;
})(window, document);